(ns hai.home.events
  "Home page lifecycle: init/teardown fan-out and the clock handle."
  (:require
   [hai.home.calendar :as calendar]
   [hai.notes.stacks :as stacks]
   [hai.tasks.data :as tasks]
   [hai.ui.rf-sugar :refer [>e defevent defevent-fx]]))

;; ---------------------------------------------------------------------------
;; Page lifecycle
;; ---------------------------------------------------------------------------

(defevent-fx :home/init [_ _]
  ;; The clock lives in the route lifecycle, not a view, so meeting statuses
  ;; and countdowns keep refreshing on both the desktop and mobile bodies.
  (let [handle (js/setInterval #(>e [::calendar/tick]) 60000)]
    {:fx [[:dispatch [:home/set-clock-handle handle]]
          [:dispatch [::calendar/init]]
          [:dispatch [::stacks/load :desktop]]
          ;; Home is a personal "my day" surface — it loads the tasks assigned
          ;; to me (which the progress/calendar widgets read too).
          [:dispatch [::tasks/load-tasks-assigned-to-me]]]}))

(defevent-fx :home/teardown [{:keys [db]} _]
  (let [handle (get db :home/clock-handle)]
    (when handle (js/clearInterval handle))
    {:db (dissoc db :home/clock-handle)
     :fx [[:dispatch [::calendar/teardown]]
          [:dispatch [::tasks/clear]]
          [:dispatch [::stacks/clear]]]}))

(defevent :home/set-clock-handle [db handle]
  (assoc db :home/clock-handle handle))
